(function(){
  if(localStorage.getItem('arissai_popup_seen')) return;
  if(/bot|crawler|spider|HeadlessChrome/i.test(navigator.userAgent)) return;

  /* arissai-popup-style-v2 */
  function ensurePopupStyles(){
    if(document.getElementById('arissai-popup-style-v2')) return;
    var style=document.createElement('style');
    style.id='arissai-popup-style-v2';
    style.textContent=`
      #arissai-popup-overlay{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;padding:16px;font-family:inherit;isolation:isolate}
      #arissai-popup-overlay .ap-bg{position:absolute;inset:0;background:rgba(0,0,0,.58);backdrop-filter:blur(2px)}
      #arissai-popup-overlay .ap-box{position:relative;z-index:1;width:min(420px,100%);max-height:calc(100dvh - 32px);overflow:auto;background:#fff;color:#121212;padding:30px 26px 24px;border-radius:16px;box-shadow:0 24px 70px rgba(0,0,0,.28);text-align:left}
      #arissai-popup-overlay .ap-close{position:absolute;top:10px;right:12px;width:38px;height:38px;border:0;border-radius:999px;background:#f1f1f1;color:#121212;font-size:28px;line-height:1;cursor:pointer}
      #arissai-popup-overlay .ap-eye{font-size:22px;margin-bottom:18px}
      #arissai-popup-overlay .ap-kicker{font-size:12px;font-weight:700;letter-spacing:.12em;color:#555;margin-bottom:14px}
      #arissai-popup-overlay .ap-h{margin:0;font-size:clamp(30px,8vw,42px);line-height:1.08;letter-spacing:-.03em;color:#121212}
      #arissai-popup-overlay .ap-pct{font-weight:700}
      #arissai-popup-overlay .ap-p{margin:18px 0;color:#555;font-size:16px;line-height:1.5}
      #arissai-popup-overlay #ap-form{display:flex;gap:10px;align-items:stretch;margin-top:18px}
      #arissai-popup-overlay #ap-form input[type="email"]{min-width:0;flex:1;height:46px;padding:0 14px;border:1px solid #d7d7d7;border-radius:9px;background:#fff;color:#121212;font:inherit;font-size:14px}
      #arissai-popup-overlay #ap-form button,#arissai-popup-overlay .ap-shop-btn{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 18px;border:0;border-radius:9px;background:#121212;color:#fff;font:inherit;font-weight:700;text-decoration:none;cursor:pointer}
      #arissai-popup-overlay .ap-success[hidden],#arissai-popup-overlay #ap-form[hidden]{display:none!important}
      #arissai-popup-overlay .ap-code-label{margin-top:16px;font-size:11px;font-weight:700;letter-spacing:.14em;color:#666}
      #arissai-popup-overlay .ap-code{display:inline-block;margin:8px 0 4px;padding:10px 14px;border:1px dashed #121212;border-radius:8px;font-size:22px;font-weight:700;letter-spacing:.08em}
      #arissai-popup-overlay .ap-p-small{font-size:14px}
      #arissai-popup-overlay .ap-fine{margin:18px 0 0;color:#777;font-size:13px;line-height:1.4}
      @media(max-width:520px){
        #arissai-popup-overlay{padding:14px}
        #arissai-popup-overlay .ap-box{width:100%;max-height:calc(100dvh - 28px);padding:26px 20px 22px;border-radius:14px}
        #arissai-popup-overlay .ap-h{font-size:34px}
        #arissai-popup-overlay #ap-form{flex-direction:column}
        #arissai-popup-overlay #ap-form button{width:100%}
      }
    `;
    document.head.appendChild(style);
  }

  var shown = false;
  function show(){
    if(shown) return; shown=true;

    ensurePopupStyles();

    var overlay = document.createElement('div');
    overlay.id = 'arissai-popup-overlay';
    overlay.setAttribute('data-testid','arissai-popup');
    overlay.innerHTML = `
    <div class="ap-bg"></div>
    <div class="ap-box" role="dialog" aria-modal="true" aria-label="10% off your first Arissai order">
      <button class="ap-close" aria-label="Close" data-testid="popup-close">&times;</button>
      <div class="ap-eye">&#9673;</div>
      <div class="ap-kicker">WELCOME OFFER&nbsp;&middot;&nbsp;1ST ORDER</div>
      <h2 class="ap-h">Take an extra<br><span class="ap-pct">10% off</span><br>your first order.</h2>
      <p class="ap-p">Get 10% off your first order. Enter your email to reveal the code.</p>
      <form id="ap-form" action="/contact#contact_form" method="post" accept-charset="UTF-8" enctype="multipart/form-data" novalidate>
        <input type="hidden" name="form_type" value="customer">
        <input type="hidden" name="utf8" value="&#10003;">
        <input type="hidden" name="contact[tags]" value="newsletter,popup,first-order-10">
        <input type="email" name="contact[email]" required placeholder="your@email.com" autocomplete="email" data-testid="popup-email">
        <button type="submit" data-testid="popup-submit">Reveal My Code</button>
      </form>
      <div id="ap-success" class="ap-success" hidden>
        <div class="ap-code-label">YOUR CODE</div>
        <div class="ap-code" data-testid="popup-code">ARISSAI10</div>
        <p class="ap-p ap-p-small">Copied to your clipboard. Use it at checkout &mdash; or just shop, we&rsquo;ll email it too.</p>
        <a class="ap-shop-btn" href="/collections/featured-picks" data-testid="popup-shop">Shop Featured Picks &rarr;</a>
      </div>
      <p class="ap-fine">No spam. Unsubscribe any time.</p>
    </div>`;
    document.body.appendChild(overlay);
    document.body.style.overflow='hidden';

    function close(){
      overlay.remove();
      document.body.style.overflow='';
      localStorage.setItem('arissai_popup_seen','1');
    }
    overlay.querySelector('.ap-close').addEventListener('click', close);
    overlay.querySelector('.ap-bg').addEventListener('click', close);
    document.addEventListener('keydown', function esc(e){
      if(e.key==='Escape'){ close(); document.removeEventListener('keydown', esc); }
    });

    overlay.querySelector('#ap-form').addEventListener('submit', function(e){
      e.preventDefault();
      var emailEl = overlay.querySelector('input[name="contact[email]"]');
      var email = emailEl && emailEl.value;
      if(!email) return;
      localStorage.setItem('arissai_popup_seen','1');
      localStorage.setItem('arissai_first_order_code','ARISSAI10');
      try { var fd = new FormData(e.target);
            fetch('/contact#contact_form', { method:'POST', body: fd, mode:'no-cors' });
      } catch(err) {}
      try { navigator.clipboard && navigator.clipboard.writeText('ARISSAI10'); } catch(err) {}
      try { if(window.pintrk) pintrk('track','lead',{lead_type:'newsletter'}); } catch(err){}
      try { if(window.fbq) fbq('track','Lead'); } catch(err){}
      overlay.querySelector('#ap-form').setAttribute('hidden','');
      overlay.querySelector('#ap-success').removeAttribute('hidden');
    });
  }

  // Trigger 1: after 18s on page
  var timer = setTimeout(show, 18000);

  // Trigger 2: exit intent (desktop)
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY < 10) show();
  });

  // Trigger 3 (mobile): IntersectionObserver on a sentinel placed ~60% down the page.
  // Far cheaper than scroll listener — fires once, never on every frame.
  function setupSentinel(){
    if(!('IntersectionObserver' in window)) return;
    var s = document.createElement('div');
    s.style.cssText = 'position:absolute;pointer-events:none;height:1px;width:1px;left:0;';
    // Defer DOM read until next frame to avoid forced reflow during page init.
    requestAnimationFrame(function(){
      var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      s.style.top = Math.round(docH * 0.55) + 'px';
      document.body.appendChild(s);
    });
    var io = new IntersectionObserver(function(entries){
      if(entries[0] && entries[0].isIntersecting){
        io.disconnect();
        s.remove();
        show();
      }
    });
    io.observe(s);
  }
  if(document.readyState !== 'loading') setupSentinel();
  else document.addEventListener('DOMContentLoaded', setupSentinel);
})();
